import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { BannerConfigService } from '../../service/banner-config.service';
import { BannerConfig } from '../../models/config/banner-config.model';
import { GlobalService } from 'src/app/service/global.service';
import { CommissionSummaryService } from '../../service/commission-summary.service';
import { CommSummaryModel } from '../../models/commissionsummary/commsummary.model';

@Component({
  selector: 'app-banner-config',
  templateUrl: './banner-config.component.html',
  styleUrls: ['./banner-config.component.css']
})
export class BannerConfigComponent implements OnInit {

  public bannerConfig: BannerConfig = {
    message: '',
    startTime: '',
    endTime: '',
    timezone: 'America/New_York',
    isActive: 'N',
    salesChannel: '',
    blockAccess: 'N'
  };

  public timezones: string[] = [
    'America/New_York'
  ];

  public salesChannelsData: CommSummaryModel[] = [];
  public filteredSalesChannelsData: CommSummaryModel[] = [];

  public showPreview: boolean = false;
  public showLoading: boolean = false;
  public loggedinUser: string = '';
  public isAccessDisabled: boolean = false;

  constructor(
    private globalService: GlobalService,
    private bannerConfigService: BannerConfigService,
    private authGaurdService: AuthGaurdService,
    private notificationService: NotificationService,
    private commissionSummaryService: CommissionSummaryService
  ) { }

  ngOnInit(): void {
    this.isAccessDisabled = this.globalService._permissionCheck('banner-config');
    
    this.loggedinUser = this.authGaurdService.loginUser();
    this.loadSalesChannels();
    this.loadBannerConfig();
  }

  public loadSalesChannels(): void {
    this.commissionSummaryService.getDropDownsData().subscribe(
      (response: CommSummaryModel[]) => {
        this.salesChannelsData = response;
        // Filter to get unique sales channels
        this.filteredSalesChannelsData = this.salesChannelsData.filter((v, i) => 
          this.salesChannelsData.findIndex(item => item.salesChannel != "" && item.salesChannel == v.salesChannel) === i
        );
        // Sort alphabetically
        this.filteredSalesChannelsData = this.filteredSalesChannelsData.sort((a, b) => 
          (a.salesChannel < b.salesChannel) ? -1 : 1
        );
      },
      (errorResponse: HttpErrorResponse) => {
        this.notificationService.sendNotification(
          NotificationType.ERROR,
          'Error loading sales channels'
        );
      }
    );
  }

  public loadBannerConfig(): void {
    this.showLoading = true;
    this.bannerConfigService.getBannerConfig().subscribe(
      (config: BannerConfig) => {
        this.bannerConfig = config;
        this.showLoading = false;
      },
      (errorResponse: HttpErrorResponse) => {
        this.showLoading = false;
        this.notificationService.sendNotification(
          NotificationType.ERROR, 
          'Error loading banner configuration'
        );
      }
    );
  }

  public saveBannerConfig(): void {
    // Validate inputs
    if (!this.bannerConfig.message || !this.bannerConfig.startTime || !this.bannerConfig.endTime) {
      this.notificationService.sendNotification(
        NotificationType.ERROR, 
        'Please fill in all required fields'
      );
      return;
    }

    // validate date range
    const start = new Date(this.bannerConfig.startTime);
    const end = new Date(this.bannerConfig.endTime);
    
    if (end <= start) {
      this.notificationService.sendNotification(
        NotificationType.ERROR, 
        'End time must be after start time'
      );
      return;
    }

    this.showLoading = true;
    this.bannerConfigService.saveBannerConfig(this.bannerConfig).subscribe(
      (response: any) => {
        this.showLoading = false;
        if (response.success) {
          this.notificationService.sendNotification(
            NotificationType.SUCCESS, 
            'Banner configuration saved successfully'
          );
        } else {
          this.notificationService.sendNotification(
            NotificationType.ERROR, 
            'Error saving banner configuration: ' + (response.error || 'Unknown error')
          );
        }
      },
      (errorResponse: HttpErrorResponse) => {
        this.showLoading = false;
        this.notificationService.sendNotification(
          NotificationType.ERROR, 
          'Error saving banner configuration'
        );
      }
    );
  }

  public togglePreview(): void {
    this.showPreview = !this.showPreview;
  }

  public clearForm(): void {
    this.bannerConfig = {
      message: '',
      startTime: '',
      endTime: '',
      timezone: 'America/New_York',
      isActive: 'N',
      salesChannel: '',
      blockAccess: 'N'
    };
    this.showPreview = false;
  }
}
